import React, { ReactNode } from 'react';
import { Modal } from '@devstart/react-bootstrap';
import Close2 from '../../../assets/icons/close2';

type HeaderProps = {
  readonly children: ReactNode;
  readonly closeButton?: boolean;
  readonly closeIcon?: ReactNode;
  readonly onHide?: () => void;
  readonly className?: string;
};

function Header({
  children,
  closeButton = false,
  closeIcon,
  onHide,
  className
}: HeaderProps): JSX.Element {
  return (
    <Modal.Header
      data-testid='modal-header'
      closeButton={false}
      style={{ justifyContent: closeButton ? 'space-between' : 'flex-end' }}
      className={className}
    >
      {closeButton && (
        <>
          {closeIcon || (
            <Close2
              data-testid='button-close-modal-discord'
              {...(onHide && { onClick: onHide })}
              style={{ cursor: 'pointer' }}
            />
          )}
        </>
      )}
      <Modal.Title data-testid='modal-title'>{children}</Modal.Title>
    </Modal.Header>
  );
}

Header.displayName = 'Header';

export default Header;
